import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { TRANSLATION } from '../constants/state'
import technologyAttributesContainsOv from '../functions/technologyAttributesContainsOv'
import checkPerformanceFilterIsSet from '../functions/checkPerformanceFilterIsSet'
import getAttributesDisplaySettings from '../functions/getAttributesDisplaySettings'
import sortAlphabetical from '../functions/sortAlphabetical'
import TranslationCont from '../General/TranslationCont'
import checkForAttributeMapping from '../functions/checkForAttributeMapping'

const mapStateToProps = (state, ownProps) => ({
    translation: getData(state, TRANSLATION)
})


const MovieAttributesAccess = ({
    technologyAttributes,
    filterType,
    filterValue,
    queryStringValues,
    performances,
    translation
    
}) => {
    const containsOv = technologyAttributesContainsOv(technologyAttributes)
    const performanceFilterIsSet = checkPerformanceFilterIsSet(technologyAttributes, filterType, filterValue, queryStringValues)
    const {
        noAttributesWithIconsToDisplay, 
        noAttributesToDisplay, 
        noAttributesWithoutIconsToDisplay, 
        technologyAttributesWithoutIcons, 
        technologyAttributesWithIcons
    } = getAttributesDisplaySettings(
        technologyAttributes, 
        performances, 
        filterValue, 
        filterType,
        queryStringValues, 
        performanceFilterIsSet, 
        translation
    )


    if(noAttributesToDisplay) {
        return ''
    }

    const attributesToDisplay = [
        ...technologyAttributesWithIcons,
        ...technologyAttributesWithoutIcons
    ]

    const attributesSorted = sortAlphabetical(attributesToDisplay)

    return (
        <>
            <dt><TranslationCont id="availableIn" after=':'>Verfügbar in</TranslationCont></dt>
            {attributesSorted.map(({ id, name })=> (
                <dd key={id}>{checkForAttributeMapping(name, translation)}</dd> 
            ))}
        </>
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(MovieAttributesAccess)